import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { revenusService } from "../services/revenusService";
import { PeriodeQuery, ExportQuery, Periode } from "../utils/types";
import { useState } from "react";

export const useRevenusData = (query: PeriodeQuery) => {
  return useQuery({
    queryKey: ["revenus", query],
    queryFn: () => revenusService.getRevenusData(query),
  });
};

export const useExportRevenus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (query: ExportQuery) => revenusService.exportRevenus(query),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["revenus"] });
    },
  });
};

export const useRevenusPeriod = (initialPeriode: Periode = "mensuel") => {
  const [periodeActive, setPeriodeActive] = useState<Periode>(initialPeriode);

  const query: PeriodeQuery = {
    periode: periodeActive,
    dateDebut: "2024-01-01",
    dateFin: "2024-01-31",
  };

  const { data, isLoading, error, refetch } = useRevenusData(query);

  return {
    periodeActive,
    setPeriodeActive,
    data,
    isLoading,
    error,
    refetch,
  };
};
